import { __exports as u } from "../../../_virtual/useThemeWithoutDefault2.js";
import h from "react";
import m from "../../../_virtual/index6.js";
var f;
function b() {
  if (f) return u;
  f = 1, Object.defineProperty(u, "__esModule", {
    value: !0
  }), u.default = void 0;
  var l = p(h), c = m;
  function i(e) {
    if (typeof WeakMap != "function") return null;
    var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
    return (i = function(n) {
      return n ? r : t;
    })(e);
  }
  function p(e, t) {
    if (e && e.__esModule) return e;
    if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
    var r = i(t);
    if (r && r.has(e)) return r.get(e);
    var n = { __proto__: null }, _ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var o in e) if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
      var a = _ ? Object.getOwnPropertyDescriptor(e, o) : null;
      a && (a.get || a.set) ? Object.defineProperty(n, o, a) : n[o] = e[o];
    }
    return n.default = e, r && r.set(e, n), n;
  }
  function s(e) {
    return Object.keys(e).length === 0;
  }
  function d(e = null) {
    const t = l.useContext(c.ThemeContext);
    return !t || s(t) ? e : t;
  }
  return u.default = d, u;
}
export {
  b as __require
};
